module.exports = __webpack_public_path__ + "img/door.224510cb.gif";